import { Drawer } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import TitleAutocomplete from '../Title/TitleAutocomplete';
import TitleDetail from '../Title/TitleDetail';
import './headerTitleSearchAutocomplete.less';

export class HeaderTitleSearchAutocomplete extends React.Component {
	static propTypes = {
		titleLanesStore: PropTypes.object,
	};

	state = {
		sku: '',
		drawerVisible: false,
	};

	render() {
		const isMobile = this.props.isMobile();
		const { drawerVisible } = this.state;

		return (
			<div className="header-title-search-autocomplete">
				<TitleAutocomplete onSelectOption={this.openTitleDrawer}>
					<Drawer
						width={isMobile ? '100%' : '90%'}
						placement={isMobile ? 'bottom' : 'left'}
						height={isMobile ? '90%' : '100%'}
						closable={false}
						headStyle={{
							backgroundColor: '#e9ebec',
							border: 0,
							height: '100%',
						}}
						bodyStyle={{
							backgroundColor: '#e9ebec',
							border: 0,
							height: '100%',
						}}
						onClose={this.onClose}
						visible={drawerVisible}>
						{drawerVisible && (
							<TitleDetail sku={this.state.sku} communityId={0} />
						)}
					</Drawer>
				</TitleAutocomplete>
			</div>
		);
	}

	onClose = () => {
		this.setState({ drawerVisible: false });
	};

	openTitleDrawer = sku => {
		this.setState({ sku, drawerVisible: true });
	};
}

export default withIsMobile(HeaderTitleSearchAutocomplete);
